/**
 * 业务控制器
 * 使用文档地址：https://xxx.com
 */
import {localget} from 'Utils/storage'
import {getUserInfo} from 'Utils/publicFun'
import filter from 'Utils/filter'
import api from 'Plugins/api'

let VUEX_STATE = {}
let userInfo = {}
let zclxObj = {
  '10901': {zclx: 'zcGnjp', zclxS: 'zcGnjpS'},
  '10902': {zclx: 'zcGjjp', zclxS: 'zcGjjpS'},
  '10903': {zclx: 'zcJd', zclxS: 'zcJdS'},
  '10904': {zclx: 'zcHcp', zclxS: 'zcHcpS'},
  '10906': {zclx: 'zcYc', zclxS: 'zcYcS'},
}

function user(cplx) {
  // VUEX_STATE = localget('VUEX_STATE') || {}
  // let cache = VUEX_STATE.app ? VUEX_STATE.app.userInfo : ''
  // userInfo = getUserInfo(cache, cplx) //根据产品 获取权限
  // console.log(cache, '----')
  // console.log(cplx, 'cplx')
  VUEX_STATE = localget('userInfo') || {}
  let cache = VUEX_STATE
  userInfo = getUserInfo(cache, cplx) //根据产品 获取权限
  console.log(cache, '----')
  console.log(cplx, 'cplx')
}

export default class ServiceCtrl {
  /**
   * [业务控制器]
   * 添加一个业务逻辑判断：
   * 命名：this.is[该逻辑的名称] = [初始值]
   * method: _set[该逻辑的名称] () { ... }
   * new 该对象，会把所有业务逻辑判断方法（方法名开头为'_'的方法）执行一遍
   *
   * @param opt
   * @param opt.zclx 政策类型 下面为入参值，只需传入"|"前面的即可 例如：{zclx: 'zcGjjp'}
   * "zcGnjp" | "zcGnjpS" 国内机票是否开启差旅标准 | 政策设置方式
   * "zcGjjp" | "zcGjjpS" 国际机票是否开启差旅标准 | 政策设置方式
   * "zcJd"   | "zcJdS"   酒店是否开启差旅标准     | 政策设置方式
   * "zcHcp"  | "zcHcpS"  火车票是否开启差旅标准   | 政策设置方式
   * @param opt.cplx 产品类型
   */
  constructor(opt) {
    if (opt) {
      Object.assign(opt, zclxObj[opt.cplx])
    }
    user(opt.cplx)

    this.isStart = false        //是否开启差旅标准
    this.isShowCxr = true       //显示出行人(不使用 默认都显示)
    this.isDefaultName = false  //是否显示 当前登陆人名称（是否默认显示当前登录人）
    this.showtips = false       //已开启按差标等级管控出差标准，需要先选择出行人！
    this.addCxr = false         // 出行人控件新增添加出行人
    this.isShowCcsqd = false    //出差申请单是否开启

    this.isChangeVoyage = true    //查询出差申请单预订行程可否变更 10991
    this.isChangeDate = true      //"查询出差申请单 预订日期可否变更" 10992
    this.isChangeDateRange = ''   //查询出差申请单预订行程可否变更范围 10993
    this.isCcsqdGK = false      //是否按出差申请单进行管控 10999
    this.isShowAllcxr = false      //是否按是否按出差单模式增加出行人 20001 20030
    this.isCivil = false         // 是否开启公务员购票 11601010
    this.isShowPf = false       // 是否展示拼房选项
    this.isChongFuYuDing = false // 出差单模式同行程是否可重复预定（0：否；1：是；）
    this.isYinCangWangFanChengRuKou = false // 隐藏往返程入口（0：否；1：是；）
    // 把业务逻辑执行一遍缓存起来
    for (let i of Object.getOwnPropertyNames(ServiceCtrl.prototype)) {
      if (i.indexOf('_') === 0) this[i](opt)
    }
  }

  /**
   * 是否显示出行人控件
   */
  _setShowCxr(opt) {
    if (opt.tripType == 1) {
      this.isShowCxr = true
    } else {
      this.isShowCxr = false
    }
  }

  _setShowPf(opt) {
    if (userInfo.vipCorp[`${opt.zclx}Pf`] == 2 || userInfo.vipCorp[`${opt.zclx}Pf`] == 3) {
      this.isShowPf = true
    } else {
      this.isShowPf = false
    }
  }

  /**
   * 因公出行是否可新增 删除出行人
   */
  _setAddCxr(opt) {
    if (opt.tripType == 1) {
      if (userInfo.empInfo.bookOutside == 1) {
        this.addCxr = true
      }
    } else {
      this.addCxr = true
    }
  }

  /**
   * 是否开启差旅标准
   */
  _setStart(opt) {
    if (opt.tripType == 1) {
      this.isStart = userInfo.vipCorp[opt.zclx] == 1 ? true : false
    }
  }

  /**
   * 出行人是否必填  提示 当前使用的那种差旅标准 差标等级或公司统一标准
   * @param userInfo 获取当前用户信息，通过判断当前登录用户信息
   * @param zclx     否开启差旅标准 1：开启 0：不开启
   * @param zclxS    差旅标准的执行方式 1：按差标等级匹配方式 2：按公司统一标准
   *
   * @description 当前用户开启差旅标准 & 按差标等级匹配方式 showtips:true
   *              若是按公司统一标准 showtips:false
   */
  _setShowTips(opt) {
    if (opt.tripType == 1) {
      if (userInfo.vipCorp[opt.zclx] == 1 && userInfo.vipCorp[opt.zclxS] == 1) {
        this.showtips = true
      }
    }
  }

  /**
   * 出行人 是否显示当前登录人名字
   * ifBooker 1:默认当前用户预订 0:非本人预订
   */
  _setDefaultName(opt) {
    if (opt.tripType == 1 && userInfo.vipCorp.bookStyle == 1) {
      if (userInfo.empInfo.ifBooker == 1) {
        this.isDefaultName = true
      }
    }
  }

  /**
   * 是否显示出差申请单
   * @param userInfo 获取当前用户信息，通过判断当前登录用户信息
   * @param zclx     否开启差旅标准 1：开启 0：不开启
   * @param zclxS    差旅标准的执行方式 1：按差标等级匹配方式 2：按公司统一标准
   * @param sqdBookType    （员工）免申请单预订 1：开启 0：不开启
   */
  _setShowCcsqd(opt) {
    if (opt.tripType == 1 && userInfo.vipCorp.bookStyle == 2) {
      // if (userInfo.vipCorp[opt.zclx] == 1 && userInfo.vipCorp[opt.zclxS] == 1) {
      // 预订全免不显示出差申请单 走单订模式
      if (userInfo.empInfo.appBook == 0) {
        this.isShowCcsqd = true
        if (userInfo.empInfo.sqdBookType == 1) {
          this.isShowCcsqd = false
        }
      }
      // } else {
      // this.isShowCcsqd = true
      // }
    }
  }

  /**
   * 获取出差单参数控制
   * @isChangeVoyage 查询出差申请单预订行程可否变更
   * @isChangeDate 查询出差申请单 预订日期可否变更"
   * @isChangeDateRange 查询出差申请单预订行程可否变更范围
   * @isCcsqdGK 是否按出差申请单进行管控
   * @isShowAllcxr 是否按出差单模式增加出行人
   */
  async _setCcsqdParams(opt) {
    if (opt.tripType == 1 && userInfo.vipCorp.bookStyle == 2 && this.isShowCcsqd) {
      try {
        let res = await api['common/queryParameter']({
          paramNos: '10991,10992,10993,10999,20001,20030,20033,10915'
        })
        let cache = res.data || {}
        let params = cache.parameterResponses || []
        params.forEach(item => {
          if (item.paramNo == 10991) {
            this.isChangeVoyage = item.value1 == 1
          } else if (item.paramNo == 10992) {
            this.isChangeDate = item.value1 == 1
          } else if (item.paramNo == 10993) {
            this.isChangeDateRange = item.value1
          } else if (item.paramNo == 10999) {
            this.isCcsqdGK = item.value1 == 1
          } else if (item.paramNo == 20001) {
            this.istrOrtkShowAllcxr = item.value1 == 1
          } else if (item.paramNo == 20030) {
            this.ishtShowAllcxr = item.value1 == 1
          } else if (item.paramNo === '20033') {
            this.isChongFuYuDing = item.value1 === '1'
          } else if (item.paramNo === '10915') {
            this.isYinCangWangFanChengRuKou = item.value1 === '1'
          }
        })
      } catch (err) {
        console.error(err)
      }
    } else {
      let res = await api['common/queryParameter']({
        paramNos: '10915'
      })
      let cache = res.data || {}
      let params = cache.parameterResponses || []
      params.forEach(item => {
        if (item.paramNo === '10915') {
          this.isYinCangWangFanChengRuKou = item.value1 === '1'
        }
      })
    }
  }


  /**
   * 获取本次预订的最低差标等级
   * @param {Array: TravelList} travelList 出行人数组
   * @returns {Object}
   * —————> @empName 最低差标等级人名
   * —————> @minzj   最低差标等级
   */
  getClbzMinZj(travelList) {
    let minzj = 9999, minzjName = ''
    // 按差标等级匹配 - 按出行人最低差标等级匹配差旅标准
    if (this.showtips) {
      travelList.map(travel => {
        if (travel.empRank < minzj && travel.empRank >= 0) {
          minzj = travel.empRank
          minzjName = filter.getName(travel)
        }
      })
      // 选择的出行人没有差标等级，则匹配当前登录人的差标
      if (minzj === 9999) {
        minzj = userInfo.empInfo.empRank || 0
        minzjName = userInfo.empInfo.empName || ''
      }
    } else if (travelList[0]) {
      // 按公司统一标准匹配 - 选择的出行人是谁就显示为谁的差标
      // 选了多个人，就显示第一个人的名字的差标
      minzj = travelList[0].empRank || 0
      minzjName = filter.getName(travelList[0]) || ''
    }
    return {minzjName, minzj}
  }

  async _isCivil() {
    let {data = {}} = await api['common/queryVipParameter']({
      paramNo: '11601010'
    })
    this.isCivil = data.value1 || 0
  }


}
